import React, { memo, useCallback } from 'react';
import { StyleSheet } from 'react-native';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import Button from 'design-system/Button';
import { rem } from 'design-system/values';
import LogoStack from 'design-system/LogoStack';
import { CardView } from 'design-system/CardView';
import { useTabNavigation } from 'hooks/navigation/useTabNavigation';
import { useAppSelector } from 'store/hooks';
import { selectIsGBUser } from 'reducers/selectors';
import { UnavailableOnWebModal } from 'utils/packages/UnavailableOnWebModal';
import { isWeb } from '../../../../constants';
const vanEck = require('../../img/vanEck.png');
const iShares = require('../../img/iShares.png');
const vanguard = require('../../img/vanguard.png');
const blackRock = require('../../img/blackRock.png');
const logos = [vanguard, blackRock, vanEck, iShares];
const StartInvestingCard = memo(() => {
    const isGBUser = useAppSelector(selectIsGBUser);
    const { navigateToTab } = useTabNavigation();
    const handleNavigation = useCallback(() => {
        if (isWeb) {
            UnavailableOnWebModal.show('emma://invest/account', 'Set up investment account');
            return;
        }
        navigateToTab('Invest');
    }, []);
    if (!isGBUser)
        return null;
    return (<CardView noMarginTop style={styles.container}>
      <LogoStack logos={logos}/>
      <Spacer.H16 />
      <Text Text-16>Start investing</Text>
      <Spacer h={4}/>
      <Text TextThin-14 centered Secondary>
        Invest in globally diversified ETFs and funds. Capital at Risk.
      </Text>
      <Spacer.H16 />
      <Button hug small brandReversed onPress={handleNavigation} title="Set up investment account"/>
    </CardView>);
});
export default StartInvestingCard;
const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        paddingVertical: rem(24),
        paddingHorizontal: rem(32),
    },
});
